import { render, staticRenderFns } from "./otherDjPay.vue?vue&type=template&id=4ba8850d&"
import script from "./otherDjPay.vue?vue&type=script&lang=js&"
export * from "./otherDjPay.vue?vue&type=script&lang=js&"
import style0 from "./otherDjPay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports